import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { WebsocketService } from 'src/app/service/websocketservice';
import { LoginService } from 'src/app/service/login.service';
import { SuscriptionService } from 'src/app/service/suscription.service';

@Component({
  selector: 'app-device-connect-success',
  templateUrl: './device-connect-success.component.html',
  styleUrls: ['./device-connect-success.component.scss']
})
export class DeviceConnectSuccessComponent implements OnInit, OnDestroy {

  qr: string = "";
  mensajeError: string = "";
  conectado: boolean = false;
  webhookEnlazado: boolean = false;

  constructor(private router: Router) {}

  ngOnDestroy(): void {}

  ngOnInit(): void {}

  redirectHome(): void {
    this.router.navigate(['/dashboard'])
  }
  redirectaccount(): void {
    this.router.navigate(['/account'])
  }
  redirectDevice(): void {
    this.router.navigate(['/devices'])
  }
  redirectChats(): void {
    this.router.navigate(['/chat'])
  }

}
